//import { usePreferences } from '@react-admin/ra-preferences';
import { usePreferences } from './usePreferences';

const useColumnsPreferences = (resource, initialValue) => usePreferences(`${resource}.list.columns`, initialValue);

export default useColumnsPreferences
